export const API_END_POINT = process.env.NODE_ENV == 'development' ? 
  'https://r4j1ruop41.execute-api.ap-northeast-1.amazonaws.com/dev' : 
  'https://4agbwtjoy7.execute-api.ap-northeast-1.amazonaws.com/prod';
